/* eslint-disable max-len */
/* eslint-disable no-console */
import React from 'react';
import { get, onValue, ref, remove, set } from 'firebase/database';
import { addDoc, arrayRemove, arrayUnion, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, setDoc, startAfter, updateDoc, where, writeBatch } from 'firebase/firestore';
import { MdOutlineDescription } from 'react-icons/md';
import { firebaseDB, firebaseRealtimeDB } from './useFirebase';
// import { firebaseDB, firebaseRealtimeDB } from './setup';
// import { store } from '../redux/store';

export const getDocByDocumentId = async (collectionName, documentId) =>
{
	const docRef = doc(firebaseDB, collectionName, documentId);
	const docSnap = await getDoc(docRef);

	// docSnap is the result, which contains the document data (or null if the document doesn't exist).

	return docSnap;
};

export const getMessages = async (id) =>
{
	const unreadMsg = [];
	const unreadMsgIds = [];

	const res = query(collection(firebaseDB, 'messages'), orderBy('createdAt', 'asc'), where('chatId', '==', id), where('msgStatus', '<', 3));

	const previousMsg = await getDocs(res);

	previousMsg?.forEach((each) =>
	{
		const eachData = each?.data();

		unreadMsg.push(eachData.text.toString());
		unreadMsgIds.push(each.id.toString());
	});

	return [ unreadMsg, unreadMsgIds ];
};

export const createDocByDocumentId = async (collectionName, documentId, body) =>
{
	try
	{
		await setDoc(doc(firebaseDB, collectionName, documentId), body);
	}
	catch (e)
	{
		console.log('errrrr', e);
		throw new Error(e);
	}
};

export const updateDocAndDeleteSubcollection = async (
	collectionName, documentId, updateData) =>
{
	try
	{
		console.log('Updating document:', collectionName, documentId, updateData);

		// Update the document
		await updateDoc(doc(firebaseDB, collectionName, documentId), updateData);

		// Delete the subcollection
		const subcollectionRef = collection(firebaseDB, collectionName, documentId, 'candidates');
		const snapshot = await getDocs(subcollectionRef);

		// Create a batch for deletion
		const batch = writeBatch(firebaseDB);

		snapshot.docs.forEach((docitem) =>
		{
			batch.delete(docitem.ref);
		});

		// Commit the batch delete
		await batch.commit();

		console.log('Document updated and subcollection deleted successfully');
	}
	catch (e)
	{
		console.log('Error occurred:', e);
		throw new Error('Failed to update document and delete subcollection. Please try again later.');
	}
};
export const updateDocByDocumentId = async (collectionName, documentId, body) =>
{
	try
	{
		// if (store.getState()?.userInfo?.userInfo?.presenceEnabled)
		if (documentId)
		{
			await updateDoc(doc(firebaseDB, collectionName, documentId), body);
		}
	}
	catch (e)
	{
		console.log('updateError', e);
		throw new Error('Failed to update document. Please try again later.');
	}
};

/**
 * Atomically add or remove an element from any array field in a Firestore document
 * @param {string} collectionName - The collection name (e.g., 'groups', 'users')
 * @param {string} documentId - The document ID
 * @param {string} fieldName - The array field name (e.g., 'blockedBy', 'members', 'tags')
 * @param {any} value - The value to add or remove from the array
 * @param {boolean} isAdding - true to add to array, false to remove from array
 */
export const updateArrayField = async (collectionName, documentId, fieldName, value, isAdding) =>
{
	try
	{
		if (!collectionName || !documentId || !fieldName || value === undefined)
		{
			throw new Error('Invalid parameters: collectionName, documentId, fieldName, and value are required');
		}

		const updateData = {
			[fieldName] : isAdding
				? arrayUnion(value) // Add to array
				: arrayRemove(value) // Remove from array
		};

		await updateDoc(doc(firebaseDB, collectionName, documentId), updateData);
	}
	catch (e)
	{
		console.log(`${fieldName} array update error`, e);
		throw new Error(`Failed to update ${fieldName} array. Please try again later.`);
	}
};

/**
 * Atomically add or remove an element from the blockedBy array in a group document
 * @param {string} groupId - The group document ID
 * @param {Object} blockedEntry - The blocked entry object { id: string, timestamp: number }
 * @param {boolean} isBlocking - true to add to blockedBy (block), false to remove (unblock)
 * @deprecated Use updateArrayField instead for better reusability
 */
export const updateBlockedByArray = async (groupId, blockedEntry, isBlocking) =>
{
	return updateArrayField('groups', groupId, 'blockedBy', blockedEntry, isBlocking);
};
export const deleteDocumentByDocumentId = async (collectionName, documentId) =>
{
	try
	{
		console.log('Deleting document:', collectionName, documentId);
		await deleteDoc(doc(firebaseDB, collectionName, documentId));
		console.log('Document deleted successfully');
	}
	catch (e)
	{
		console.log('deleteError', e);
		throw new Error('Failed to delete document. Please try again later.');
	}
};

export const updateMultipleDocuments = async (collectionName, documents, updateBody) =>
{
	const batch = writeBatch(firebaseDB);

	documents.forEach((item) =>
	{
		batch.update(doc(firebaseDB, collectionName, item?.id), updateBody);
	});

	try
	{
		await batch.commit();
	}
	catch (error)
	{
		throw new Error('Failed to update multiple documents. Please try again later.');
	}
};
export const deleteMultipleDocuments = async (collectionName, documents) =>
{
	try
	{
		const batch = writeBatch(firebaseDB);

		documents.forEach((item) =>
		{
			const docRef = doc(firebaseDB, collectionName, item.id);

			batch.delete(docRef);
		});

		await batch.commit();
		console.log('Documents deleted successfully');
	}
	catch (error)
	{
		console.error('Error deleting multiple documents:', error);
		throw new Error('Failed to delete multiple documents. Please try again later.');
	}
};

export const getDocuments = async (collectionName, whereConditions, lastDocument = null) =>
{
	whereConditions = Array.isArray(whereConditions)
		? whereConditions
		: [ whereConditions ];

	try
	{
		let q = query(collection(firebaseDB, collectionName), ...whereConditions);

		if (lastDocument)
		{
			q = query(q, startAfter(lastDocument));
		}
		const res = await getDocs(q);

		return res;
	}
	catch (e)
	{
		console.error('error in getDocuments', e);
		throw new Error('Failed to retrieve documents. Please try again later.', e);
	}
};

export const dbListener = (collectionName, condition, order, callback) =>
{
	// console.log('listening to db***', collectionName);

	const collectionRef = query(collection(firebaseDB, collectionName), order, condition);

	return onSnapshot(collectionRef, callback, (error) =>
	{
		console.log('dlksdiuyfsd', error);
		throw new Error('Real-time update failed. Please try again later.', error);
	});
};

export const calldbListener = (collectionName, documentId, callback) =>
{
	const docRef = doc(firebaseDB, collectionName, documentId);

	const unsubscribe = onSnapshot(docRef, (each) =>
	{
		if (each.exists())
		{
			// eslint-disable-next-line n/no-callback-literal
			callback({ id: each.id, ...each.data() });
		}
		else
		{
			console.log('No such document!');
		}
	}, (error) =>
	{
		console.error('Error listening to document:', error);
	});

	return unsubscribe;
};

export const listenToSubcollectionChanges = (
	parentCollectionName, parentDocId, subcollectionName, callback) =>
{
	const subcollectionRef = collection(firebaseDB, parentCollectionName,
		parentDocId, subcollectionName);

	const unsubscribe = onSnapshot(subcollectionRef, (snapshot) =>
	{
		const documents = snapshot.docs.map((ele) => ({ id: ele.id, ...ele.data() }));

		callback(documents);
	}, (error) =>
	{
		console.error('Error listening to subcollection changes: ', error);
	});

	return unsubscribe;
};

export const addDocToSubcollection = async (parentCollectionName, parentDocId,
	subcollectionName, subDocData) =>
{
	try
	{
		const subcollectionRef = collection(firebaseDB, parentCollectionName,
			parentDocId, subcollectionName);

		const res = await addDoc(subcollectionRef, subDocData);

		return res;
	}
	catch (e)
	{
		console.error('Error adding document to subcollection: ', e);
	}
};

// export const userDbListener = (collectionName, condition, callback) =>
// {
// 	const collectionRef = query(collection(firebaseDB, collectionName), condition);

// 	return onSnapshot(collectionRef, callback, (error) =>
// 	{
// 		console.error(error);
// 		throw new Error('Real-time update failed. Please try again later.');
// 	});
// };

export const DeletedMsgDbListener = (collectionName, callback, condition1, condition2) =>
{
	let collectionRef;

	if (condition2)
	{
		collectionRef = query(collection(firebaseDB, collectionName), condition1, condition2);
	}
	else
	{
		collectionRef = query(collection(firebaseDB, collectionName), condition1);
	}

	return onSnapshot(collectionRef, callback, (error) =>
	{
		console.error(error);
		throw new Error('Real-time update failed. Please try again later.');
	});
};

export const MsgDbListener = (collectionName, callback, condition1, condition2) =>
{
	let collectionRef;

	if (condition2)
	{
		collectionRef = query(collection(firebaseDB, collectionName), condition1, condition2);
	}
	else
	{
		collectionRef = query(collection(firebaseDB, collectionName), condition1);
	}

	return onSnapshot(collectionRef, callback, (error) =>
	{
		console.error(error);
		throw new Error('Real-time update failed. Please try again later.');
	});
};

export const getCountByAllDocuments = async (collectionName, ...whereConditions) =>
{
	try
	{
		const q = query(collection(firebaseDB, collectionName), ...whereConditions);
		const res = await getDocs(q);

		return res.size;
	}
	catch (e)
	{
		throw new Error('Failed to count documents. Please try again later.');
	}
};

export const searchUsersByEmail = async (email) =>
{
	try
	{
		const q = query(
			collection(firebaseDB, 'users'),
			where('email', '==', email),
			where('inlynkUserData.isDeleted', '==', false),
			where('inlynkUserData.isActive', '==', 'active')
		);

		const querySnapshot = await getDocs(q);

		return querySnapshot.docs.map((item) => ({ id: item.id, ...item.data() }));
	}
	catch (e)
	{
		throw new Error('Failed to fetch user by Email. Please try again later.', e);
	}
};

export const presenceImageTypes = [ 'png', 'jpg', 'jpeg', 'gif', 'image/png', 'image/jpg', 'image/jpeg', 'img', 'webp', 'heic' ];
export const presenceVideoTypes = [ 'mp4', 'mkv', 'mov', 'webm', 'video/mp4', 'video/mkv', 'video/mov', 'video/webm', 'video', 'MP4' ];
export const presenceDocumentTypes = [ 'txt', 'pdf', 'xlsx', 'xls', 'ppt', 'csv', 'pptx', 'doc', 'docx', 'xml', 'zip', 'html', 'json', 'file', 'svg', 'rar', 'md' ];
export const presenceAudioTypes = [ 'mp3', 'wav', 'audio' ];
export const presenceAllMediaTypes = [ ...presenceImageTypes, ...presenceVideoTypes,
	...presenceDocumentTypes, ...presenceAudioTypes ];
export const acceptFormats = '.txt, .pdf, .doc, .html, .json, .mp3, audio, .wav, .zip, .docx, .mp4, .mkv, .mov, .webm, video/mp4, video/mkv, video/mov, video/webm, .xls, .xlsx, .csv, .ppt, .pptx, .xml, .png, .jpg, .jpeg, .gif, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, text/csv, application/xml, image/png, image/jpg, image/jpeg, image/gif';
export const imgPathByDocType = {
	txt     : 'documents/txt.png',
	pdf     : 'documents/pdf.png',
	xml     : 'documents/xml.svg',
	html    : 'documents/html.svg',
	csv     : 'documents/csv.svg',
	json    : 'documents/json.svg',
	zip     : 'documents/zip.png',
	doc     : 'documents/doc.png',
	docx    : '/documents/docx.png',
	ppt     : 'documents/ppt.png',
	pptx    : '/documents/pptx-file.png',
	xlsx    : '/documents/xlsx.png',
	xls     : '/documents/xls.png',
	mp3     : 'documents/mp3.png',
	default : <MdOutlineDescription />
};
export const statusNames = {
	away        : 'Away',
	outOfOffice : 'Out of Office',
	dnd         : 'Do not disturb',
	available   : 'Available',
	busy        : 'Busy',
	inMeeting   : 'In a Meeting',
	coffeeBreak : 'Coffee Break',
	travelling  : 'Travelling',
	beRightBack	: 'Be right back',
	offline    	: 'Offline'
};

export const getRelativeDate = (timestamp) =>
{
	const inputDate = new Date(timestamp);

	const today = new Date();

	today.setHours(0, 0, 0, 0);
	const todayTime = today.valueOf();

	const todayEnd = new Date(today);

	todayEnd.setHours(23, 59, 59, 999);
	const todayEndTime = todayEnd.valueOf();

	const yesterday = new Date(today);

	yesterday.setDate(today.getDate() - 1);
	const yesterdayTime = yesterday.valueOf();

	const inputTime = inputDate.valueOf();

	if (inputTime >= todayTime && inputTime <= todayEndTime)
	{
		return 'Today';
	}
	else if (inputTime >= yesterdayTime && inputTime < todayTime)
	{
		return 'Yesterday';
	}
	else
	{
		return inputDate.toLocaleDateString('en-US', {
			day   : '2-digit',
			month : 'long',
			year  : 'numeric'
		});
	}
};

export const sortItemsByDate = (inputData) =>
{
	const data = {};

	inputData.forEach((i) =>
	{
		const timeStamp = new Date(i?.createdAt).setHours(0, 0, 0, 0)
			.valueOf();

		if (!data[timeStamp])
		{
			data[timeStamp] = [];
		}
		data[timeStamp].push(i);
	});

	const sortedObj = Object.fromEntries(
		Object.entries(data).sort(([ a ], [ b ]) => b - a)
	);

	return sortedObj;
};

export const refDoc = (path) =>
{
	return ref(firebaseRealtimeDB, `UserStatus/${path}`);
};

export const getRealTimeUser = async (path) =>
{
	const docRef = refDoc(path);

	const docSnap = await get(docRef);

	return docSnap.val();
};

export const checkRealtimeDatabaseConnection = async () =>
{
	const connectedRef = ref(firebaseRealtimeDB, '.info/connected');
	let isConnected = false;

	onValue(connectedRef, (snapshot) =>
	{
		isConnected = snapshot.val();
	});

	return isConnected;
};

export const listenToUserStatus = (id, callback) =>
{
	const dbRef = refDoc(id);

	return onValue(dbRef, (snapshot) =>
	{
		if (snapshot.exists())
		{
			callback(snapshot.val());
		}
		else
		{
			console.error('No data available!');
		}
	}, (error) =>
	{
		console.error('Error listening to data:', error);
	});
};

export const updateStatus = (status, userId) =>
{
	console.log('rerererere', status);
	const userStatusRef = refDoc(userId);

	return set(userStatusRef, {
		status,
		timestamp : new Date().valueOf(),
		updatedAt : new Date().valueOf()
	});
};

export const userOnlineStatus = (userId, deviceId, statusData) =>
{
	return set(ref(firebaseRealtimeDB, `UserDeviceStatus/${userId}/${deviceId}`), {
		...statusData
	});
};

export const removeUserOnlineStatus = (userId, deviceId) =>
{
	return remove(ref(firebaseRealtimeDB, `UserDeviceStatus/${userId}/${deviceId}`));
};

export const userStatusListener = (id, callback, onNoData, onError) =>
{
	const dbRef = refDoc(id);

	return onValue(
		dbRef,
		(snapshot) =>
		{
			if (snapshot.exists())
			{
				callback(snapshot.val(), id);
			}
			else
			{
				onNoData?.(id); // Only call if provided
			}
		},
		(error) =>
		{
			onError?.(error, id); // Only call if provided
		}
	);
};
